// tog'a #3151 / #3158 / #3171 (2026-10-03): «Заявки на перевод» — zakazning yetmagan qismi uchun skladdan ASOSIY skladga so'rov.
// Sklad bilan glavniy o'rtasida faqat perevod (sotuv emas); asosiy skladda tovar bo'lmasa ham so'rov kutadi.
// «Перемещения» sarlavhasidagi tugma (kutilayotganlar soni bilan) → ro'yxat: «Создать перевод» (TR-… tuziladi, zakaz qoldig'iga bog'lanadi)
// yoki «Отклонить» (sabab bilan — zakaz qoldig'i menejerga qaytadi). Backend: api/TransferRequests.
import React, { useState } from "react"
import { Badge, Button, Drawer, Empty, Input, Modal, Radio, Spin, Tag, Tooltip, message } from "antd"
import StickyTable from "../table/StickyTable"   // tog'a #4695/#4703: hamma jadvalda sarlavha va «Итого» qotadi
import { SwapOutlined } from "@ant-design/icons"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import moment from "moment"
import i18n from "../../services/i18n"
import { request } from "../../utils/config"

const t = (k: string, d: string) => i18n.t(k, d)
const err = (e: any) => e?.response?.data?.message || e?.response?.data?.Message || e?.message || String(e)
const STATUS: Record<number, { c: string; l: () => string }> = {
  0: { c: "gold", l: () => t("trqPending", "⏳ Ожидает") },
  1: { c: "green", l: () => t("trqCreated", "✅ Перевод создан") },
  2: { c: "red", l: () => t("trqRejected", "❌ Отклонена") },
  9: { c: "default", l: () => t("trqCancelled", "Отменена (заказ отменён)") },
}

export function TransferRequestsButton({ className }: { className?: string }) {
  const [open, setOpen] = useState(false)
  const { data } = useQuery(["TRANSFER_REQUESTS", 0], async () => (await request({ url: "TransferRequests", params: { status: 0 } })).data || [], { refetchInterval: 60000, retry: false })
  const n = Array.isArray(data) ? data.length : 0
  return (
    <>
      <Tooltip title={t("trqTitle", "Заявки на перевод (остаток заказов)")}>
        <Badge count={n} size="small" offset={[-6, 6]}>
          <Button size="large" className={className} icon={<SwapOutlined />} onClick={() => setOpen(true)} data-testid="transfer-requests-open">
            <span className="hide-xs">{t("trqButton", "Заявки")}</span>
          </Button>
        </Badge>
      </Tooltip>
      {open && <TransferRequestsDrawer onClose={() => setOpen(false)} />}
    </>
  )
}

function TransferRequestsDrawer({ onClose }: { onClose: () => void }) {
  const qc = useQueryClient()
  const [st, setSt] = useState<number>(0)
  const { data, isFetching, refetch } = useQuery(["TRANSFER_REQUESTS", st], async () => (await request({ url: "TransferRequests", params: { status: st } })).data || [], { keepPreviousData: true })
  const [busy, setBusy] = useState<number | null>(null)
  const yangila = () => { refetch(); qc.invalidateQueries(["TRANSFER_REQUESTS"]) }
  const yarat = async (r: any) => {
    setBusy(r.id)
    try { const x = (await request({ url: `TransferRequests/${r.id}/Fulfill`, method: "POST" })).data; message.success(t("trqDone", "Перевод создан") + ": " + (x?.transferNumber || "")); yangila() }
    catch (e: any) { message.error(err(e)) } finally { setBusy(null) }
  }
  const rad = (r: any) => {
    let sabab = ""
    Modal.confirm({
      title: t("trqRejectTitle", "Отклонить заявку на перевод"),
      content: <Input.TextArea rows={3} maxLength={300} placeholder={t("trqRejectReason", "Причина (обязательно) — менеджер решит, что делать с остатком заказа")} onChange={(e) => { sabab = e.target.value }} />,
      okText: t("trqReject", "Отклонить"), okButtonProps: { danger: true }, cancelText: t("cancel", "Отмена"), zIndex: 1020,
      onOk: async () => {
        if (sabab.trim().length < 3) { message.error(t("trqReasonMin", "Укажите причину (минимум 3 символа)")); throw new Error("reason") }
        try { await request({ url: `TransferRequests/${r.id}/Reject`, method: "POST", data: { reason: sabab.trim() } }); message.success(t("trqRejectedOk", "Заявка отклонена")); yangila() }
        catch (e: any) { message.error(err(e)); throw e }
      },
    })
  }
  return (
    <Drawer visible destroyOnClose zIndex={1000} width="min(1100px, 100vw)" onClose={onClose} title={"🔁 " + t("trqTitle", "Заявки на перевод (остаток заказов)")} data-testid="transfer-requests-drawer">
      <div style={{ fontSize: 13, opacity: 0.85, marginBottom: 10 }}>{t("trqHelp", "Склад принял часть заказа, остаток просит у основного склада. Между складами — только перевод. Если товара нет — заявка ждёт; создайте перевод, когда товар поступит.")}</div>
      <Radio.Group value={st} onChange={(e) => setSt(e.target.value)} buttonStyle="solid" style={{ marginBottom: 12 }}>
        <Radio.Button value={0}>{t("trqTabPending", "Ожидают")}</Radio.Button>
        <Radio.Button value={-1}>{t("trqTabAll", "Все")}</Radio.Button>
      </Radio.Group>
      <Spin spinning={isFetching}>
        <StickyTable size="small" rowKey="id" pagination={false} dataSource={data || []} scroll={{ x: "max-content" }} locale={{ emptyText: <Empty description={t("trqNone", "Заявок нет")} /> }}
          columns={[
            // iPad (1180 px) da gorizontal surilmasin: sana ikki qatorda, soni va «на основном» bitta katakda
            { title: t("date", "Дата"), dataIndex: "createdAt", render: (v: string) => <div style={{ whiteSpace: "nowrap" }}>{moment(v).format("DD.MM.YYYY")}<div style={{ fontSize: 11, opacity: 0.7 }}>{moment(v).format("HH:mm")}</div></div> },
            { title: t("trqOrder", "Заказ"), dataIndex: "orderDocument", render: (v: string) => <b style={{ wordBreak: "break-all" }}>{v}</b> },
            { title: t("product", "Товар"), dataIndex: "product", render: (v: string, r: any) => <div style={{ minWidth: 120 }}><b>{v}</b>{r.article ? <div style={{ fontSize: 11, opacity: 0.7 }}>{r.article}</div> : null}</div> },
            {
              title: t("count", "Кол-во"), dataIndex: "qty", align: "right" as const,
              render: (q: number, r: any) => <div style={{ whiteSpace: "nowrap" }}><b>{q}</b>{r.available == null ? null : <div style={{ fontSize: 11, fontWeight: 600, color: r.available + 0.0001 >= q ? "#16a34a" : "#dc2626" }}>{t("trqAvailable", "На основном")}: {r.available}</div>}</div>,
            },
            { title: t("trqFromTo", "Откуда → куда"), key: "w", render: (_: any, r: any) => <div style={{ minWidth: 140 }}>{r.from} → <b>{r.to}</b></div> },
            { title: t("status", "Статус"), dataIndex: "status", render: (s: number, r: any) => <div><Tag color={STATUS[s]?.c}>{STATUS[s]?.l()}</Tag>{r.transferNumber ? <div style={{ fontSize: 11 }}>{r.transferNumber}</div> : null}{r.decisionNote ? <div style={{ fontSize: 11, color: "#b45309" }}>{r.decisionNote}</div> : null}</div> },
            {
              title: "", key: "a", fixed: "right" as const, render: (_: any, r: any) => r.canDecide ? (   // iPad: tugma o‘ng chetda qirqilmasin
                <span style={{ display: "inline-flex", gap: 6 }}>
                  <Button size="small" type="primary" loading={busy === r.id} onClick={() => yarat(r)} disabled={r.available != null && r.available + 0.0001 < r.qty} data-testid="transfer-request-fulfill">🔁 {t("trqCreate", "Создать перевод")}</Button>
                  <Button size="small" danger onClick={() => rad(r)} data-testid="transfer-request-reject">✕</Button>
                </span>
              ) : null,
            },
          ]} />
      </Spin>
    </Drawer>
  )
}
